import ajax from './index'
import apiEnv from './apiEnv'



//大咖面对面管理列表
export function masterList(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/master/page`,data)
}
//大咖面对面新增
export function addMaster(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/master/add`,data)
}
//大咖面对面获取详情
export function getMasterDetail(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/master/detail`,data)
}
//大咖面对面编辑详情保存接口
export function updateDetail(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/master/update`,data)
}
//删除
export function delMaster(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/master/delete/master`,data)
}
//发布和取消发布
export function publishApi(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/master/controlShow`,data)
}